import { colors } from '@material-ui/core'

export const getPalette = (pageProps) => {
  const { dark, main, light } = pageProps.palette

  const white = '#FFFFFF'
  const black = '#333'

  return {
    black,
    white,
    primary: {
      contrastText: white,
      dark: dark,
      main: main,
      light: light,
    },
    secondary: {
      contrastText: white,
      dark: '#cc1f20',
      main: '#FF2728',
      light: '#ff5455',
    },
    success: {
      contrastText: white,
      dark: '#228300',
      main: '#32C100',
      light: '#42FF00',
    },
    info: {
      contrastText: white,
      dark: '#34515e',
      main: '#607d8b',
      light: '#8eacbb',
    },
    warning: {
      contrastText: white,
      dark: '#c79100',
      main: '#FFC107',
      light: '#fff350',
    },
    error: {
      contrastText: white,
      dark: '#BA473B',
      main: '#ff6150',
      light: '#FF8C7F',
    },
    text: {
      primary: '#575757',
      secondary: '#727272',
      link: colors.blue[600],
    },
    background: {
      default: '#F4F6F8',
      paper: white,
    },
    icon: colors.blueGrey[600],
    divider: '#ccc',
  }
}
